import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';

import PatientsListForMerge from './PatientsListForMerge';
import Button from '../../../components/Button';
import AreYouSureModal from '../../../components/DialogModals/AreYouSureModal';
import {mergeDuplicatesPatients} from '../../../services/api/index';

function MergePatientModal(props) {
  const {
    open,
    setOpenMergePatientsModal,
    classes: {
      modal,
      modalContent,
      button,
    },
    history,
    patientsForMerge,
    setPatientsForMerge,
    fetchPatients,
    setMergeMode,
  } = props;

  const [confirmMergeDialog, setConfirmMergeDialog] = useState(false);
  const [primPatientId, setPrimPatientId] = useState();

  const confirmMergeDialogMessage = <span>Merging patients will migrate all patient's details and<br/> 
                                          history to the primary patient and is irreversible.</span>
  
  const executePatientMerge = async primPatientId => { 
    setOpenMergePatientsModal(false);
    setConfirmMergeDialog(false);
    const dupPatientsIds = patientsForMerge.map(v=>v.id);
    dupPatientsIds.splice(dupPatientsIds.indexOf(primPatientId),1);

    await mergeDuplicatesPatients(primPatientId,dupPatientsIds);
    setPatientsForMerge([]);
    setMergeMode(false);
    fetchPatients();
  };
  
   return (
    <Dialog
      fullWidth
      open={open}
      // disableBackdropClick
      onClose={()=> setOpenMergePatientsModal(false)}
      classes={{ paper: modal }}
    >
    <DialogTitle>Please Select Primary Patient</DialogTitle>

    <DialogContent classes={{ root: modalContent }}>
        <PatientsListForMerge
          history={history}
          patientsForMerge={patientsForMerge}
          setPatientsForMerge = {setPatientsForMerge}
          setPrimPatientId = {setPrimPatientId} 
          setConfirmMergeDialog = {setConfirmMergeDialog}
        />
    </DialogContent> 
    <Button
      onClick={()=> setOpenMergePatientsModal(false)}
      variant="contained"
      color="primary"
      className={button}
    >
      Cancel
    </Button>
    {confirmMergeDialog &&
      <AreYouSureModal
        open = {confirmMergeDialog}
        message = {confirmMergeDialogMessage}
        confirmButtonTag = {'COMPLETE MERGE'}
        executMethod = {()=> executePatientMerge(primPatientId)}
        onClose ={()=> setConfirmMergeDialog(false)}
      >
      </AreYouSureModal>}
  </Dialog>
  );
}

MergePatientModal.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
    maxWidth: '480px',
  },
  modalContent: {
    overflow: 'visible',
    padding: '0px',
  },
  button: {
    width: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0px',
    marginBottom: '15px',
  },
});

export default withStyles(styles)(MergePatientModal);
